import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { trim } from 'lodash';
import { recentOneYearStr, recentOneYearEndStr } from '../../utils/calcDatetime';

const [
  LIST_BUYS_ESTIMATE,
  LIST_BUYS_ESTIMATE_SUCCESS,
  LIST_BUYS_ESTIMATE_FAILURE,
] = createRequestActionTypes('chance/LIST_BUYS_ESTIMATE');

export const listBuysEstimate = createAction(
  LIST_BUYS_ESTIMATE,
  (searchData) => ({ salesType: 'B', searchData }),
);
const listBuysEstimateSaga = createRequestSaga(
  LIST_BUYS_ESTIMATE,
  projectApi.getEstimateFiles,
);

const UNLOAD_BUYS_ESTIMATE = 'chance/UNLOAD_BUYS_ESTIMATE';
export const unloadBuysEstimate = createAction(UNLOAD_BUYS_ESTIMATE);

const SET_BUYS_ESTIMATE_FITERS = 'chance/SET_BUYS_ESTIMATE_FITERS';
export const setBuysEstimateFilters = createAction(
  SET_BUYS_ESTIMATE_FITERS,
  (filters) => filters,
);

const RESET_BUYS_ESTIMATE_FILTERS = 'chance/RESET_BUYS_ESTIMATE_FILTERS';
export const resetBuysEstimateFilters = createAction(
  RESET_BUYS_ESTIMATE_FILTERS,
);

export function* buysEstimateSaga() {
  yield takeLatest(LIST_BUYS_ESTIMATE, listBuysEstimateSaga);
}

const initialState = {
  files: null,
  error: null,
  defaultFilters: {
    searchKeyword: 'cstNm',
    searchWords: '',
    // 비워두지 않고 오늘 기준 앞뒤 1년을 기본 조회범위로 둔다.
    searchStrtDt: recentOneYearStr,
    searchEndDt: recentOneYearEndStr,
  },
};

const buysEstimate = handleActions(
  {
    [LIST_BUYS_ESTIMATE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUuid: file.fileUuid,
        filePartnerNm: file.filePartnerNm,
        filePartnerUuid: file.filePartnerUuid,
        fileNm: trim(file.fileNm),
        fileUrl: file.fileUrl,
        prjNo: file.prjNo,
        prjUuid: file.prjUuid,
        cstNm: file.cstNm,
        fileRegDt: file.fileRegDt,
        fileCrtDt: file.fileCrtDt,
        fileCrtNm: file.fileCrtNm,
      })),
      error: null,
    }),
    [LIST_BUYS_ESTIMATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_BUYS_ESTIMATE]: () => initialState,
    [RESET_BUYS_ESTIMATE_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_BUYS_ESTIMATE_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default buysEstimate;
